import { Controller } from "@hotwired/stimulus"
import { lock, unlock } from "../helpers/body_scroll_lock"

export default class extends Controller {
  static targets = ["sheet", "backdrop"]

  open() {
    this.element.classList.remove("hidden")
    this.backdropTarget.classList.remove("hidden")
    requestAnimationFrame(() => {
      this.backdropTarget.classList.remove("opacity-0")
      this.sheetTarget.classList.remove("translate-y-full")
    })
    lock()
  }

  comingSoon(event) {
    const label = event.currentTarget.querySelector("span")?.textContent?.trim() || "This feature"
    const toast = document.createElement("div")
    toast.className = "fixed top-20 left-1/2 -translate-x-1/2 z-50 rounded-full bg-gray-800 dark:bg-gray-700 px-4 py-2 text-sm font-medium text-white shadow-lg transition-opacity duration-300"
    toast.textContent = `${label} is coming soon!`
    document.body.appendChild(toast)
    setTimeout(() => { toast.classList.add("opacity-0") }, 2000)
    setTimeout(() => { toast.remove() }, 2300)
  }

  close() {
    this.backdropTarget.classList.add("opacity-0")
    this.sheetTarget.classList.add("translate-y-full")
    unlock()
    this.sheetTarget.addEventListener("transitionend", () => {
      this.backdropTarget.classList.add("hidden")
      this.element.classList.add("hidden")
    }, { once: true })
  }
}
